// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('configuration.handlingFees', {
    url: '/handlingfees',
    templateUrl: 'main/configuration/handlingFees/handlingFees.tpl.html',
    data: { pageTitle: 'Handling fees' },
  });
};

angular.module('configuration.handlingFees', []).config(config);
